import { useState } from "react";
import { useAuth } from "../../context/AuthContext";

// "Include my photo" for one download, starting from the My Profile setting.
export function useCvPhoto() {
  const { user } = useAuth();
  const [on, setOn] = useState(Boolean(user?.cv_photo));
  const available = Boolean(user?.has_photo);
  const include = available && on;
  return { available, include, setOn, picture: include ? user.picture : null, query: include ? "&photo=true" : "" };
}

export function PhotoToggle({ photo, testid = "cv-photo-toggle" }) {
  if (!photo.available) return null;
  return (
    <label className="flex items-start gap-2.5 text-sm text-ink cursor-pointer select-none" data-testid={testid}>
      <input type="checkbox" checked={photo.include} onChange={(e) => photo.setOn(e.target.checked)} data-testid={`${testid}-input`}
        className="mt-0.5 w-4 h-4 accent-[var(--gi-brand,#1D5BFF)]" />
      <span>Include my photo</span>
    </label>
  );
}
